import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ReportDataTabs = ({
  tabNames,
  activeTabIndex,
  onSelectTab,
}) => (
  <div className="c-inner-wrapper c-custom-report-data-tabs" display-if={tabNames.length > 2}>
    {tabNames.map((dataTabName, index) => (
      <button
        // eslint-disable-next-line react/no-array-index-key
        key={`${dataTabName}-${index}`}
        className={classnames(
          'c-btn c-btn--blank u-text-left u-p-',
          { 'c-btn--link': index === activeTabIndex }
        )}
        onClick={() => onSelectTab(index)}
      >
        {dataTabName}
      </button>
    ))}
  </div>
);

ReportDataTabs.propTypes = {
  tabNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  onSelectTab: PropTypes.func.isRequired,
};

export default ReportDataTabs;
